export default function HoverFace() {
  return (
    <img
      src={process.env.PUBLIC_URL + "/images/48AllModelsareWrongHover.jpg"}
      alt=""
    />
  );
}
